import axios from 'axios'

var myaxios = axios.create({
    baseURL: "https://www.districloud.net/app/service/rest/ws.php?action=api_mobile"
})

export default myaxios
